import { axios } from '../../plugins/axios'

export default {
  namespaced: true,

  state: {
    dependencias: [],
  },

  getters: {
    getDependencias: (state) => {
      return state.dependencias
    },
  },

  mutations: {
    SET_DEPENDENCIAS(state, dependencias) {
      state.dependencias = dependencias
    },
  },

  actions: {
    fetchDependencias: async function ({ commit }) {
      await axios
        .get('/EonCloud/common/dependencias')
        .then((response) => {
          commit('SET_DEPENDENCIAS', response.data.data)
        })
        .catch((error) => console.log(error))
    },
  },
}
